import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { isRouteAuthorized } from '@/shared/lib/routePermissions';
import { sessionAtom } from '@/shared/store/atoms/sessionAtom';
import { jotaiStore } from '@/shared/store/store';
import { AppShell } from '@/shared/ui/organisms/AppShell';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    const session = jotaiStore.get(sessionAtom);

    if (!session) {
      throw redirect({ to: '/login' });
    }

    // Master tem acesso irrestrito a todas as rotas
    if (session.roles.includes('Master')) return;

    // Evita loop infinito ao redirecionar para a própria página de não autorizado
    if (location.pathname.startsWith('/unauthorized')) return;

    // Sem nenhuma permissão → bloqueia tudo
    if (session.controllerPermissions.length === 0) {
      throw redirect({ to: '/unauthorized' });
    }

    if (!isRouteAuthorized(location.pathname, session.controllerPermissions)) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
